import { ScreenType } from './ScreenType';

export default class ScreenContent {
    public Id: number = 0;
    public ScreenId: number = 0;
    public ScreenType: ScreenType = 1;
    public ContentId: number = 1;
}
